module.exports = __webpack_public_path__ + "static/media/39pic.de2c142b.jpg";